<template>
    <div>
        <div class="container" v-if="action_loading">
            <div class="row">
                <div class="loading-sm"></div>
            </div>
        </div>
        <div v-else class="container">
            <div class="">
              <div>Order number: {{order_data.order_no}}</div>
              <div>Date: {{order_data.order_date}}</div>
              <div>Order Amount: &#8358;{{order_data.order_items_total}}</div>
              <div>Shipping:  &#8358;{{order_data.order_shipping_total}}</div>
              <div>Total: &#8358;{{order_data.order_total}}</div>
              <div>Status: <span :style="{color:order_data.order_status_color}">{{order_data.order_status}}</span></div>
            </div>
            
            <div style="clear: both"></div>
            
            <div class="card" style="background-color: bisque; padding: 1em; border-radius: 12px;">
              <h3 style="float: right; text-decoration: underline;">SELLER</h3>
              <div class="card" style="clear: right;">
                <h4>Shopping List</h4>
                <p v-for="item in order_data.order_items" :key="item.order_item_no">
                  {{item.product_name}} - &#8358;{{item.order_item_total.toFixed(2)}}
                </p>
                <!--cta-->
                <div>
                  <button class="btn sp-button-02" @click="toggleSingleComponent('setPaymentDetails')"><i class="fa fa-check"></i> Yes, I have these Items</button>
                </div>
                <!--./cta-->
                <!--cta-details-->
                <div id="setPaymentDetails" style="display: none;">
                  <div><hr/>
                    <b>Send Bank Details</b><br>
                    <div v-if="sellpoint.business_bank_details && (Object.keys(sellpoint.business_bank_details).length > 0)">
                      <span>Send bank details details to receive order payment</span>
                      <div>
                        <p style="color:#444444;">{{ sellpoint.business_bank_details.bank_name }}<br>
                          {{ sellpoint.business_bank_details.bank_account_name }}<br>
                          {{ sellpoint.business_bank_details.bank_account_number }}
                        </p>
                      </div>
                      <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomOrderDetailsUpdate(order_data)">Send</button>
                    </div>
                    <div v-else>
                      <p><b>Set Bank details</b></p>
                    </div>
                  </div>
                  <hr/>
                  <p><b>Send Payment Link</b><br>
                    <span>A Payment link with payment details would be generated for payment</span><br><br>
                    <button type="button" class="sp-button sp-button-lt">Send Payment Link</button>
                  </p>
                  <hr/>
                  <button type="button" class="sp-button sp-button-lt" @click="setMenuTabInnerView('ConfirmPaymentUpdate')">Confirm Payment</button>
                  <div v-if="menu_tab_inner_view['ConfirmPaymentUpdate']">
                    <p style="color:#ff0000">Confirm Order Payment ?</p>
                    <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomConfirmPaymentUpdate(order_data)">Yes, Confirm Payment</button>
                  </div>
                  <hr/>
                </div>
                <!--./cta-details-->
              </div>
            </div>
            <div class="">
              <div class="card-row">
                <h5>Order Additional Information</h5>
                <p style="color:#e94b4b">Add any order addtional information</p>
                <div v-if="setAddOrderAdditionalView">
                    <form class="form-inline">
                        <div class="row">
                            <div class="form-group wnf-fl-form-group col-xs-12">
                                <label class="">Title</label>
                                <input class="form-control input-bflat" type="text" v-model="order_add_info.title" title="Enter  name" placeholder=""/>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group wnf-fl-form-group col-xs-12">
                                <label class="">Details</label>
                                <textarea class="form-control input-bflat" v-model="order_add_info.details" placeholder=""></textarea>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group wnf-fl-form-group col-xs-12">
                                <label class="">Cost</label>
                                <input class="form-control input-bflat" type="text" v-model="order_add_info.cost" title="Enter  name" placeholder=""/>
                            </div>
                        </div>
                    </form>
                    <div class="row">
                        <a style="cursor: pointer; color: #ffffff; text-decoration: none;" @click="addOrderAdditionalView">Add Information to Order</a>
                    </div>
                </div>
                <div v-else>
                    <a style="cursor: pointer; color: #ffffff; text-decoration: none;" @click="setAddOrderAdditionalView = true">Add Information</a>
                </div>
              </div>
              <!---->
              <div class="card-row">
                <h5>Process Order Request</h5>
                <p></p>
                
                <hr/>
                <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomUpdates(order_data,'delivered',3)">Mark as delivered</button>
                <hr/>
                <hr/>
                <button type="button" class="sp-button sp-button-lt" @click="setOrderCustomUpdates(order_data,'closed',3)">Close Order</button>
                <hr/>
                
                <div></div>
              </div>
              <!--./-->
            </div>
        
            <div class="mobile-fix-nav-2"  v-if="order_data.order_payment_status_id != 18">
                <p style="padding:0 5px">{{data_processing_message}}</p>
                <div v-if="order_data.order_status_id == 7" style="background: #e94b4b; width: 100vw; padding: 0.8em; text-align: center;">
                    <a style="cursor: pointer; color: #ffffff; text-decoration: none;" @click="updateOrders(order,'delivered')">Confirm Order Delivered </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>
<script>
//import Account from './../../Resources/script.js'


import commonfunctions from "../../Account/Resources/commonfunctions";
export default {
    mixins: [commonfunctions],
    props: ['order_data'],
    data () {
        return {
            order_add_info:{},
            setAddOrderAdditionalView:false,
        }
    },
    components: {
        
    },
     
    methods: {
      setPage(){
        this.loading = true;
        //check if request is a single order route
        let set_business = this.$route.params.business;
        let set_order_ref = this.$route.params.ref;
        if((set_business != undefined) && (set_business != '')){
          if((set_order_ref != undefined) && (set_order_ref != '')){
            //get order details
            var payload = {
              ref: set_order_ref
            }
            this.getOrderDetails(payload);
            //get business details
          }
        }
      },

      
    },

    created: function(){
      let self = this;
      localforage.getItem(this.getService.bdb_name, function(err, value) { //quick with the callback version
        if(value != undefined) {
          self.sellpoint = value;console.log(self.sellpoint)
          //self.setPage();
        }
      });
      // localforage.getItem('xvue', function(err, value) { //quick with the callback version
      //     if(value != undefined) {
      //         self.sellpoint =  value.account.store_sellpoint.store_sellpointData;
      //         //set sellpoint
      //         self.setPage();
      //     }else{}
      // });
    }
}
</script>



// WEBPACK FOOTER //
// OrderDetailsRequest.vue?b304e9b8